import * as React from 'react'
import { withAuthenticationRequired } from '@auth0/auth0-react'

type Props = {
  component: React.ComponentType
}

const PrivateRoute: React.FC<Props> = ({ component }) => {
  const ProtectedComponent = withAuthenticationRequired(component)
  return <ProtectedComponent />
}

export default PrivateRoute
